import { Component, Vue, Prop } from 'vue-property-decorator';

import { PaymentMethod } from '@/core/payment-methods/interfaces';
import { PAYMENT_METHOD_ID } from '@/core/payment-methods/constants';

@Component
export default class PaymentButton extends Vue {
    @Prop()
    label: string;

    @Prop()
    currencySymbol: string;

    @Prop()
    amount: string;

    @Prop(Boolean)
    hasAmount: boolean;

    @Prop(Boolean)
    disabled: boolean;

    @Prop(Boolean)
    hideAmountDetails: boolean;

    @Prop()
    exchangeCurrencySymbol: string;

    @Prop()
    exchangeAmount: string;

    @Prop(Object)
    paymentMethod: PaymentMethod;

    @Prop({ default: 'paymentButton' })
    buttonName: string;

    get ariaLabel() {
        const label = this.label ? this.label : this.$t('common:pay');

        if (this.hideAmountDetails) {
            return label;
        }

        const amount = (this.currencySymbol && this.amount) ? ` ${this.currencySymbol}${this.amount}` : '';
        const exchangeRate = (this.exchangeCurrencySymbol && this.exchangeAmount) ? ` (${this.exchangeCurrencySymbol}${this.exchangeAmount})` : '';

        return label + amount + exchangeRate;
    }
}
